import React from 'react';
import TopBar from "./TopBar";
import MenuBar from './MenuBar';

const Header = () => {
  return (
    <header>
      <TopBar />
      <MenuBar />
    </header>
  );
};

export default Header;
